import http from './http.config'

export const fetchDashboardSummary = (params = {}) =>
  http.get('/customer/dashboard/summary', { params }).then((res) => res.data)

export const fetchCompanies = (params = {}) =>
  http.get('/customers/companies', { params }).then((res) => res.data)

export const getAvailableCompanies = (params = {}) =>
  http.get('/customers/company-available', { params }).then((res) => res.data)

export const fetchCustomerSubscriptions = (params = {}) =>
  http.get('/customers/subscriptions', { params }).then((res) => res.data)

export const fetchCustomerSubscriptionDetail = (id: string | number) =>
  http.get(`/customers/subscriptions/${id}/details`).then((res) => res.data)

export const customerContext = (payload: { company_code: string }) =>
  http.post('/customer-context', payload).then((res) => res.data)
